<section class="section-pd list-wrapper-style-2 tailoredSolutions">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>與您專屬軟體及工作流程無縫整合</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 提供簡單的整合方案，讓您的團隊能直接在現有軟體中使用，讓寫作更有效率、流程更順暢。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>JavaScript 整合</h3>

                    <p>
                        只需在瀏覽器或任意應用程式中插入一段簡短的 JavaScript（JS）程式碼，即可為所有團隊成員啟用 Trinka。
                    </p>

                    <a [routerLink]="['/enterprise']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>API 整合</h3>
                    <p>
                        Trinka 強大的 API 可無縫嵌入您現有的應用程式，透過簡潔的架構設計，讓整合變得輕鬆又快速。
                    </p>

                    <a [routerLink]="['/enterprise/grammar-checker-api']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>內部部署</h3>
                    <p>
                        將 Trinka 部署於您企業的本地或雲端伺服器，確保寫作效率同時達到最高等級的資料保密與控管。
                    </p>

                    <a [routerLink]="['/enterprise']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>
                        雲端編輯器
                    </h3>
                    <p>
                        隨時隨地使用 Trinka 的完整功能，安全的網頁應用助您輕鬆寫作。
                    </p>
                    <a [routerLink]="['/trinkacloud']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>
                        MS Word 外掛程式
                    </h3>
                    <p>
                        透過 MS Word 內建的寫作建議，提升團隊的工作效率。
                    </p>
                    <a [routerLink]="['/wordplugin']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>
                        瀏覽器擴充功能
                    </h3>
                    <p>
                        支援您常用瀏覽器的即時寫作協助，隨時隨地提升文字品質。
                    </p>
                    <a [routerLink]="['/browser-plugin']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
